import { useSelector, shallowEqual, TypedUseSelectorHook } from "react-redux";
import RootState from "../redux/types/rootState";

// Özel useShallowSelector hook'u
export const useShallowSelector: TypedUseSelectorHook<RootState> = (selector) =>
  useSelector(selector, shallowEqual);
